<i18n>
{
	"no": {
		"other": "Standard",
		"title": "Behandlingsregel"
	},
	"en": {
		"other": "Default",
		"title": "Treatmentrule"
	}

}
</i18n>
<template>
	<t-form-group :title="$t('title')">
		<t-text-input
			v-model="controLevelName"
			disabled
		/>
	</t-form-group>
  
</template>

<script>
export default {

	props: {
		controlLevelDto: Object
	},

	computed: {
		controLevelName() {
			return this.getControlLevelName();
		}
	},
	methods: {
		getControlLevelName() {
			if (!this.controlLevelDto)
				return this.$t('other');
			return this.controlLevelDto.description;
		}
	}
};
</script>

<style>

</style>